import React, { useEffect, useState } from 'react'

import {
  Container,
  Popover,
  Option,
  Button,
  LabelWrapper,
  IconWrapper,
  // ButtonContainer,
} from './styles'

import { Pencil } from '@icons'

const DrawButton = ({ drawPolygon, drawFreeHand }) => {
  const [active, setActive] = useState(false)

  const handleClick = event => {
    const button = document.getElementById('drawButton')
    const container = document.getElementById('drawButtonContainer')
    const apply = document.getElementById('drawButtonApply')
    const cancel = document.getElementById('drawButtonCancel')

    if (
      button?.contains(event.target) ||
      container?.contains(event.target) ||
      apply?.contains(event.target) ||
      cancel?.contains(event.target)
    )
      return

    setActive(false)
  }

  useEffect(() => {
    document.addEventListener('mousedown', handleClick, true)
    return () => {
      document.removeEventListener('mousedown', handleClick, true)
    }
  })

  return (
    <Container className="DrawButtonComponent">
      {active && (
        <Popover id="drawButtonContainer">
          <Option
            onClick={() => {
              setActive(false)
              drawPolygon()
            }}
          >
            <p>Polígono</p>
          </Option>
          <Option
            onClick={() => {
              setActive(false)
              drawFreeHand()
            }}
          >
            <p>Mão livre</p>
          </Option>
        </Popover>
      )}

      <Button id="drawButton" type="button" onClick={() => setActive(!active)}>
        <LabelWrapper>
          <IconWrapper>
            <Pencil />
          </IconWrapper>
          <p>Desenhar no mapa</p>
        </LabelWrapper>
      </Button>
      {/* ) : (
        <ButtonContainer>
          <Button
            actionBtn
            id="drawButtonApply"
            type="button"
            onClick={stopDrawing}
          >
            Aplicar
          </Button>
          <Button
            actionBtn
            cancel
            id="drawButtonCancel"
            type="button"
            onClick={cancelDrawing}
          >
            Cancelar
          </Button>
        </ButtonContainer>
      )} */}
    </Container>
  )
}

export default DrawButton
